import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { getAuth } from 'firebase/auth';
import { appFirebase } from './credenciales';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import DashAdmin from '../components/dashAdmin/dashAdmin';

const auth = getAuth(appFirebase);
const db = getFirestore(appFirebase); // Inicializa Firestore

function ProtectedRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [dash, setDash] = useState(children);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        try {
          // Obtener el documento del usuario desde Firestore
          const userRef = doc(db, 'users', user.uid);
          const userDoc = await getDoc(userRef);

          if (userDoc.exists()) {
            const userData = userDoc.data();
            
            // Verifica si es admin desde la base de datos
            if (userData.typeUser === 'admin') {
              setDash(<DashAdmin />);
            } else {
              setDash(children); // Si no es admin, muestra el contenido normal
            }

            setIsAuthenticated(true);
          } else {
            console.log('El usuario no está registrado en la base de datos');
            setIsAuthenticated(false);
          }
        } catch (error) {
          console.error('Error al obtener los datos del usuario:', error);
          setIsAuthenticated(false);
        }
      } else {
        setIsAuthenticated(false);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [children]);

  if (loading) {
    return <div>Loading...</div>; // Muestra un spinner o un mensaje de carga
  }

  return isAuthenticated ? dash : <Navigate to="/login" />;
}

export default ProtectedRoute;
